"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueVisitPlanCountDto = exports.VenueVisitPlanTimeSlotCountDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class VenueVisitPlanTimeSlotCountDto {}
exports.VenueVisitPlanTimeSlotCountDto = VenueVisitPlanTimeSlotCountDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueVisitPlanTimeSlot
}), __metadata("design:type", String)], VenueVisitPlanTimeSlotCountDto.prototype, "timeSlot", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Personal visit plans for this venue in this time window today (server timezone).'
}), __metadata("design:type", Number)], VenueVisitPlanTimeSlotCountDto.prototype, "count", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether this time window is currently active for today (server timezone).'
}), __metadata("design:type", Boolean)], VenueVisitPlanTimeSlotCountDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether this time window has already ended for today (server timezone).'
}), __metadata("design:type", Boolean)], VenueVisitPlanTimeSlotCountDto.prototype, "isPassed", void 0);
class VenueVisitPlanCountDto {}
exports.VenueVisitPlanCountDto = VenueVisitPlanCountDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: [VenueVisitPlanTimeSlotCountDto],
  description: "Today's visit plan counts per time window, in chronological order."
}), __metadata("design:type", Array)], VenueVisitPlanCountDto.prototype, "byTimeSlot", void 0);
//# sourceMappingURL=VenueVisitPlanCount.dto.js.map